export default "__VITE_ASSET__BQHj0f7w__"